import React from 'react';
import { useDispatch } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core';
import { ConfigurationRadioGroup } from '../ConfigurationRadioGroup';
import { Checkbox } from '@components/SharedComponents/Checkbox';
import { FeaturePermissionEntityInterface, PagePermissionEntityInterface } from '@types';
import { PermissionActions } from '@enums';
import { setCurrentRolePageFeaturePermission } from '@actions/roleActions';
import { PermissionActionsNames, PermissionFeaturesAlwaysView } from '@constants/permissions';

import './index.scss';

interface Props {
  pagePermission: PagePermissionEntityInterface;
  feature: FeaturePermissionEntityInterface;
}
const FeatureConfigurationItem = ({ pagePermission, feature }: Props) => {
  const isEnabled = feature[PermissionActions.View];
  const isDisabled = PermissionFeaturesAlwaysView.includes(feature.name);
  const dispatch = useDispatch();

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.checked;
    dispatch(setCurrentRolePageFeaturePermission(pagePermission.id, feature.id, nextValue));
  };

  const featureActions = Object.keys(PermissionActionsNames).filter(
    (action) => action !== PermissionActions.View
  );

  return (
    <div className="feature-configuration-item" data-testid="feature-configuration-item">
      <Accordion
        elevation={0}
        expanded={isEnabled}
        data-testid={`feature-container-${feature.name}`}
      >
        <AccordionSummary data-testid={`feature-title-${feature.id}`}>
          <Typography
            className="feature-configuration-item-name"
            data-testid={`feature-checkbox-${feature.name}`}
          >
            <Checkbox checked={isEnabled} onChange={handleToggle} disabled={isDisabled} />
            <span className="feature-configuration-title">{feature.title}</span>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {isEnabled &&
            featureActions.map((action) => {
              return (
                feature[action] !== null && (
                  <div
                    key={`${feature.id}-${action}`}
                    className="feature-configuration-action-container"
                  >
                    <ConfigurationRadioGroup
                      pagePermission={pagePermission}
                      feature={feature}
                      action={action}
                    />
                  </div>
                )
              );
            })}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export { FeatureConfigurationItem };
